import React from "react";
import { FaArrowLeft, FaBars } from "react-icons/fa";
import NumberFormat from "react-number-format";
import { saveValues } from "../../api";
import { saveAs } from "file-saver";
import axios from "axios";
import { useBlueBody } from "../../hooks/useBlueBody";
import CurrencyInput from "../currency-input";
import * as SCREENS from "../../constants/screens";
import ServopaIcon from "../../assets/icons/servopaW.svg";

const realFormat = {
  minimumFractionDigits: 2,
  style: "currency",
  currency: "BRL",
};

function TypeInto({ dataManager, sidebarManager }) {
  const { data, setData } = dataManager;
  const { openSidebar } = sidebarManager;
  useBlueBody();

  const [inputs, setInputs] = React.useState({
    nPar: "",
    vCred: 0,
    tAdm: "",
    tRes: "",
    vLan: 0,
    sDev: 0,
    vEnt: 0,
    vPar: 0,
    nParRestantes: "",
    lanceEmbutido: 0,
    creditoTotal: 0,
  });
  const [validValues, setValidValues] = React.useState(false);
  const [showCard, setShowCard] = React.useState(false);

  React.useEffect(() => {
    showCard && showCardResult(inputs);
  }, [showCard]);

  function prevScreen() {
    const screen = data.associateMode ? SCREENS.ADMINISTRATORS : SCREENS.NAME;
    setData({ ...data, screen: screen });
  }

  function setInputsInfos(e) {
    e.preventDefault();
    console.log(e.target.name, e.target.value);
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  }

  function handleCurrency(e, value) {
    console.log(value);
    setInputs({ ...inputs, [e.target.name]: value });
  }

  async function showCardResult(values) {
    const go = await saveValues(values, data.docRef, data.administrator);
    setShowCard(go);
  }

  async function gerarResultado(adm) {
    let sdev,
      npar,
      vent,
      vpar,
      vcon,
      vlanCheio,
      sdevA,
      credTotal,
      vmeiapar,
      vvenda;
    let tresTratado = inputs.tRes.replace(",", ".");
    let tadmTratado = inputs.tAdm.replace(",", ".");
    console.log("taxas >> ", parseFloat(inputs.tRes), parseFloat(inputs.tAdm));
    let tres = parseFloat(tresTratado) / 100.0;
    let tadm = parseFloat(tadmTratado) / 100.0;
    switch (adm) {
      case "Servopa":
        vcon = inputs.vCred; //credito total
        sdev = vcon * (1 + tadm + tres);
        npar = inputs.nPar;
        vent = sdev / inputs.nPar;
        vlanCheio = sdev * (inputs.vLan / sdev + 0.3); //lance total
        vpar = (sdev - vlanCheio - vent) / (inputs.nPar - 1);
        vmeiapar = vent / 2;
        vvenda = vcon * 0.15;
        setInputs({
          ...inputs,
          sDev: sdev,
          vEnt: vent,
          vPar: vpar,
          nParRestantes: npar,
          creditoTotal: vcon,
          lanceEmbutido: vlanCheio - inputs.vLan,
          vmeiapar: vmeiapar,
          vvenda: vvenda,
        });
        break;
      default:
        break;
    }
    setShowCard(true);
  }

  function createAndDownloadPDF() {
    console.log("data >> ", inputs);
    axios
      .post(
        "https://simulador-pdf.herokuapp.com/create-pdf",
        { data: inputs, adm: data.administrator },
        {}
      )
      .then(() => {
        axios
          .get("https://simulador-pdf.herokuapp.com/fetch-pdf", {
            responseType: "blob",
          })
          .then((res) => {
            const pdfBlob = new Blob([res.data], { type: "application/pdf" });
            saveAs(pdfBlob, "proposta.pdf");
          });
      });
  }

  // console.log('type into', inputs)
  return (
    <section className="type-into-screen">
      <div className="container mb-5">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            <FaArrowLeft
              role="button"
              className="icon-bar"
              onClick={prevScreen}
            />
          </div>
          <div className="col-8">
            <div className="progress">
              <div
                className="progress-bar"
                style={showCard ? { width: "100%" } : { width: "80%" }}
                role="progressbar"
                aria-label="Progress Bar"
                aria-valuenow={showCard ? "100" : "80"}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div className="col-auto">
            <FaBars role="button" className="icon-bar" onClick={openSidebar} />
          </div>
        </div>
      </div>
      <div className="container mb-5">
        <h1>Simulação de Consórcios</h1>
        <h2>Digite os valores de cada campo.</h2>
      </div>
      <div className="bottom-panel container">
        {showCard && (
          <div className="adm-tag">
            <img
              src={
                ServopaIcon
              }
              className="icon-adm-tag"
              alt={`Icone ${data.administrador}`}
            />
            {data.administrator}
          </div>
        )}
        <div className="row-inputs">
          <p className="result-text">
            {showCard ? "Valor do Crédito" : "Valor do Crédito Desejado"}
          </p>
          {showCard ? (
            <p className="mb-1 value-to-print">
              <strong className="field-name">
                {inputs.vCred.toLocaleString("pt-BR", realFormat)}
              </strong>
            </p>
          ) : (
            <CurrencyInput
              name="vCred"
              placeholder="R$ 0,00"
              type="tel"
              max={9999999}
              onChange={handleCurrency}
              value={inputs.vCred}
              className="form-control mb-2"
              disabled={showCard}
            />
          )}
        </div>
        {!showCard &&
          <div className="row-inputs">
            <p className="result-text">
              Quantidade de Parcelas
            </p>
            <input
                placeholder="Número de parcelas"
                name="nPar"
                type="tel"
                onChange={setInputsInfos}
                value={inputs.nPar}
                className="form-control mb-2"
                disabled={showCard}
            />
          </div>
        }
        {!showCard &&
          <div className="row-inputs">
            <p className="result-text">
              Taxa de Administração
            </p>
            <NumberFormat
                placeholder="Taxa de Administração"
                suffix={"%"}
                allowNegative={false}
                allowLeadingZeros={true}
                decimalScale={2}
                inputMode="decimal"
                className="form-control mb-2"
                disabled={showCard}
                value={inputs.tAdm}
                onChange={setInputsInfos}
                allowedDecimalSeparators={[".", ","]}
                name="tAdm"
            />
          </div>
        }
        <div className="row-inputs">
          <p className="result-text">
            {showCard ? "Prazo" : "Fundo de Reserva"}
          </p>
          {showCard ? (
            <p className="mb-1 value-to-print">{inputs.nParRestantes}</p>
          ) : (
            <NumberFormat
              placeholder="Taxa do fundo de reserva"
              suffix={"%"}
              allowNegative={false}
              allowLeadingZeros={true}
              decimalScale={2}
              inputMode="decimal"
              className="form-control mb-2"
              disabled={showCard}
              value={inputs.tRes}
              onChange={setInputsInfos}
              allowedDecimalSeparators={[".", ","]}
              name="tRes"
            />
          )}
        </div>
        {!showCard && 
          <div className="row-inputs">
            <p className="result-text">
              Valor do Lance
            </p>
            <CurrencyInput
              name="vLan"
              placeholder="R$0,00"
              type="tel"
              onChange={handleCurrency}
              value={inputs.vLan}
              className="form-control mb-2"
              disabled={showCard}
            />
          </div>
        }
        {showCard &&
          <>
            <div className="row-inputs">
              <p className="result-text">
                Investimento Mensal
              </p>
              <p className="mb-1 value-to-print">
                {inputs.vmeiapar.toLocaleString("pt-BR", realFormat)}
              </p>
            </div>
            <div className="row-inputs">
              <p className="result-text">
                Retorno da venda
              </p>
              <p className="mb-1 value-to-print">
                {inputs.vvenda.toLocaleString("pt-BR", realFormat)}
              </p>
            </div>
          </>
        }
        <div className="row-inputs w-100">
          {!showCard && (
            <button
              className="btn btn-primary btn-lg col-12 mb-0"
              onClick={() => gerarResultado(data.administrator)}
              disabled={validValues}
            >
              Calcular
            </button>
          )}
          {/* {showCard && (
            <div className="row w-100 centered-div">
              <a
                className="btn btn-secondary btn-lg col-12 mb-2"
                href={data.formURI}
                rel="noopener noreferrer"
                target="_blank"
              >
                Contratar
              </a>
              <button
                className="btn btn-primary btn-lg col-12 mb-2"
                onClick={createAndDownloadPDF}
              >
                Download Proposta
              </button>
            </div>
          )} */}
        </div>
      </div>
    </section>
  );
}

export default TypeInto;
